import { motion, type Variants } from 'framer-motion'
import * as React from 'react'
import { cn } from '@/lib/utils'

interface Props {
  children: React.ReactNode
  delay?: number
  y?: number
  className?: string
  once?: boolean
}

export function Reveal({ children, delay = 0, y = 24, className, once = true }: Props) {
  const variants: Variants = {
    hidden: { opacity: 0, y },
    visible: { opacity: 1, y: 0, transition: { duration: 0.55, delay, ease: [0.22, 1, 0.36, 1] } },
  }
  return (
    <motion.div
      className={cn(className)}
      initial="hidden"
      whileInView="visible"
      viewport={{ once, margin: '-15% 0px' }}
      variants={variants}
    >
      {children}
    </motion.div>
  )
}

export function Stagger({ children, className, delayChildren = 0.08 }: { children: React.ReactNode; className?: string; delayChildren?: number }) {
  return (
    <motion.div
      className={cn(className)}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: '-15% 0px' }}
      variants={{ hidden: {}, visible: { transition: { staggerChildren: delayChildren } } }}
    >
      {children}
    </motion.div>
  )
}
